import { apiPath } from "../../constants";
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import { addSuccessMessage } from "../SnackBar";

export const RULES_COPY_REQUEST = 'COPY_RULES_REQUEST';
export const RULES_COPY_FAILURE = 'COPY_RULES_FAILURE';
export const RULES_COPY_SUCCESS = 'COPY_RULES_SUCCESS';

export const copyRule = (id, title) => {
    return function(dispatch) {
        const params = [];
        params['id'] = id;
        dispatch(copyRuleRequest());
        return axios(apiRequestOptions(apiPath.RULES.COPY, { title }, { params }))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(addSuccessMessage('Rule successfully copied'));
                dispatch(copyRuleSuccess(response.data));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(copyRuleFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const copyRuleRequest = () => ({ type: RULES_COPY_REQUEST });

const copyRuleFailure = (error) => ({ type: RULES_COPY_FAILURE, error });

const copyRuleSuccess = (rule) => ({ type: RULES_COPY_SUCCESS, rule });
